/**
 * Compatibility wrapper for react-popup under Vite.
 * The package is CJS and depends on Node's `events` module.
 */
import * as ReactPopupNS from 'react-popup-cjs';

const Popup =
  ReactPopupNS.default?.default ||
  ReactPopupNS.default ||
  ReactPopupNS;

export default Popup;
